var $ = require('jquery');

var self;
module.exports = self = {
    scan: function () {
        $.each($('form'), function (idx, form) {
            form['FormDupe'] = new FormDupe(form);
        });
    }
};

$(document).ready(function () {
    self.scan();
});

var FormDupe = function (form, manager, controlDelegates) {
    var _formDupe = this;
    this.form = $(form);
    this.allowSubmit = true;
    this.controls = $([]);
    manager = manager || Manager;
    controlDelegates = controlDelegates || {
        'button': new ButtonManager(),
        'input[type=submit]': new InputManager()
    };
    $.each(controlDelegates, function (selector, controlDelegate) {
        var $controls = _formDupe.form.find(selector);
        _formDupe.controls = _formDupe.controls.add($controls.each(function (idx, item) {
            return item['DupeControl'] = new DupeControl(new manager(controlDelegate), $(item));
        }));
    });

    this.form.on('submit', function (event) {
        var submittedButton = undefined;
        if (event !== undefined && event.originalEvent !== undefined && event.originalEvent.submitter !== undefined) {
            submittedButton = event.originalEvent.submitter;
        }
        var canSubmit = _formDupe.allowSubmit;
        _formDupe.disable(submittedButton);
        return canSubmit;
    });

    this.disable = function (submittedButton) {
        $.each(_formDupe.controls, function (idx, control) {
            control['DupeControl'].disable(submittedButton);
        });
        this.allowSubmit = false;
    };

    this.reset = function () {
        $.each(_formDupe.controls, function (idx, control) {
            control['DupeControl'].enable();
        });
        this.allowSubmit = true;
    };
};

var DupeControl = function (manager, element) {
    var _dupeControl = this;
    this.width = manager.getWidth(element);
    this.text = manager.getText(element);
    this.disabled = false;
    element.id =
    this.isDisabled = function () {
        return _dupeControl.disabled;
    };
    this.disable = function (submittedButton) {
        if (_dupeControl.isDisabled(element)) {
            return;
        }
        _dupeControl.disabled = true;
        if (submittedButton !== undefined && $(element)[0].isSameNode($(submittedButton)[0])) {
            manager.disable(element)
                .setFillerText(element)
                .setWidth(element, _dupeControl.width);
        } else {
            manager.disable(element);
        }
    };
    this.enable = function () {
        if (!_dupeControl.isDisabled(element)) {
            return;
        }
        _dupeControl.disabled = false;
        manager.enable(element)
            .setText(element, _dupeControl.text)
            .setWidth(element, '');
    }
};

var Manager = function (delegate) {
    this.delegate = delegate;
    this.getWidth = function ($element) {
        return $element.outerWidth();
    };
    this.setWidth = function($element, width) {
        $element.css('width', width);
        return this;
    };
    this.isDisabled = function ($element) {
        return $element.prop('disabled');
    };
    this.disable = function ($element) {
        // $element.prop('disabled', true);
        return this;
    };
    this.enable = function ($element) {
        // $element.prop('disabled', false);
        return this;
    };
    this.getText = function ($element) {
        return this.delegate.getText($element);
    };
    this.setText = function ($element, text) {
        this.delegate.setText($element, text);
        return this;
    };
    this.setFillerText = function ($element, text) {
        this.delegate.setFillerText($element);
        return this;
    };
};
var ButtonManager = function () {
    this.getFillerText = function () {
        return '<i class="fa fa-fw fa-spinner fa-spin"></i>';
    };
    this.setFillerText = function ($element) {
        $element.html(this.getFillerText());
    };
    this.getText = function ($element) {
        return $element.html();
    };
    this.setText = function ($element, text) {
        $element.html(text);
        return this;
    };
};
var InputManager = function () {
    _im = this;
    this.getFillerText = function () {
        return [
            '...   ',
            '.. .  ',
            '..  . ',
            '. .  .',
            '.  . .',
            '  . ..',
            '   ...',
            '   ...',
            '  . ..',
            ' .  ..',
            '.  . .',
            '. .  .',
            '.. .  ',
            '...   ',
        ];
    };
    this.setFillerText = function ($element) {
        var i = 0;
        $element.val('');
        var refreshIntervalId = setInterval(function () {
            if (!$element[0].DupeControl.isDisabled()) {
                return;
            }
            if (i == 0) {
                $element.val('');
            }
            $element.val(_im.getFillerText()[i]);
            i++;
            if (i == _im.getFillerText().length) {
                i = 0;
            }
        }, 150);
        var watcherIntervalId = setInterval(function () {
            if (!$element[0].DupeControl.isDisabled()) {
                clearInterval(refreshIntervalId);
            }
        }, 100);
    };
    this.getText = function ($element) {
        return $element.val();
    };
    this.setText = function ($element, text) {
        $element.val(text);
        return this;
    };
};
